import { Outlet, Link } from "react-router-dom"
import { Button } from "../../components/buttons"

/*
Props:
*/

const Jobs = () => {
  return (
    <div>
      Jobs
      <Button link="../company"/>
    </div>
  )
}

export default Jobs